export const SET_CLIENT_FLASH_MESSAGE = 'SET_CLIENT_FLASH_MESSAGE'
export const SET_BACKEND_FLASH_MESSAGE = 'SET_BACKEND_FLASH_MESSAGE'
